import { services } from "@/core";
import ListControllerMixin from "@/utils/ListControllerMixin";

export default {
  mounted() {
    this.loadingItems = true;
    this.getData();
  },
  mixins: [ListControllerMixin],
  data() {
    return {
      columns: [
        {
          name: "Título",
          sortName: null,
          order: null,
        },
        {
          name: "Criado em",
          sortName: null,
          order: null,
        },
      ],
    };
  },

  methods: {
    fetchPromise() {
      return services.contentsService.list({
        ...this.filters,
        orderBy: this.columns.filter(
          (r) => r.order != null && r.sortName != null,
        ),
      });
    },
  },
};
